import React, { Component } from 'react';
import { Modal, Icon, Button, List } from 'semantic-ui-react';
import ContactUs from "../../shared/components/ContactUs";

export default class DepositInfoModal extends Component {
    state = { modalOpen: false }
    handleClose = () => this.setState({ modalOpen: false })
    handleOpen = () => this.setState({ modalOpen: true })
    render() {
        return (
            <Modal
                trigger={<Icon link circular name='info' size="small" onClick={this.handleOpen} />}
                open={this.state.modalOpen}
                onClose={this.handleClose}
                closeIcon
            >
                <Modal.Header>Deposit Info</Modal.Header>
                <Modal.Content>
                    <p>To maintain the integrity of your program, deposit changes online are limited as follows:</p>
                    <List bulleted relaxed>
                        <List.Item>If you are reducing your amount or postponing your payment, at least six months has passed since your last reduction/postponement (this does not apply if you're making your payment sooner or increasing the amount).</List.Item>
                        <List.Item>If you are skipping a deposit, at least twelve months has passed since your last skipped deposit.</List.Item>
                        <List.Item>You do not have a settlement currently in progress.</List.Item>
                    </List>
                    <p>Additionally, the amount you're able to reduce your deposit may be limited as well.</p>
                    <p>If you have a circumstance where you need a deposit change outside of these restrictions, please <ContactUs /> and we will do our best to assist you.</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='green' onClick={this.handleClose}>
                        <Icon name='checkmark' /> Got it
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/DepositInfoModal/index.js